import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  UserIcon, 
  LogoutIcon, 
  AdminIcon, 
  ClearIcon,
  ChevronDownIcon
} from './Icons';

const UserPopup = ({ 
  auth, 
  onLogout, 
  onClearChat
}) => {
  const navigate = useNavigate();
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });
  const buttonRef = useRef(null);

  const handleAdminClick = () => {
    navigate('/admin');
    setPopupOpen(false);
  };

  const handleClearChat = () => {
    if (window.confirm('Clear all messages?')) {
      onClearChat();
      setPopupOpen(false);
    }
  };

  const handleLogout = () => {
    onLogout();
    setPopupOpen(false);
  };

  const togglePopup = () => {
    if (!popupOpen && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      const spacing = 8;

      setPopupPosition({
        top: rect.bottom + spacing,
        left: rect.left,
      });
    }
    setPopupOpen(!popupOpen);
  };

  // Close popup when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupOpen && buttonRef.current && !buttonRef.current.contains(event.target)) {
        // Check if click is inside the popup
        const popup = document.querySelector('.user-popup');
        if (!popup || !popup.contains(event.target)) {
          setPopupOpen(false);
        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [popupOpen]);

  return (
    <>
      <button
        ref={buttonRef}
        type="button" 
        className="user-popup-button"
        onClick={togglePopup}
        title="User Menu"
      >
        <div className="user-info-compact">
          <div className="user-avatar-small">
            <UserIcon size={20} />
          </div>
          <div className="user-details-compact">
            <span className="user-name-compact">{auth?.username || (auth?.access_code ? `AC:${auth.access_code}` : 'Undefined')}</span>
            <span className="user-role-compact">{auth?.role}</span>
          </div>
        </div>
        <ChevronDownIcon size={14} className={`chevron ${popupOpen ? 'open' : ''}`} />
      </button>
      
      {popupOpen && (
        <div 
          className="user-popup"
          style={{
            top: `${popupPosition.top}px`,
            left: `${popupPosition.left}px`,
          }}
        >
          <div className="user-popup-content">
            {/* Actions only, removed user-popup-header */}
            <div className="user-popup-actions">
              <button className="user-popup-action" onClick={handleClearChat}>
                <ClearIcon size={18} />
                <span>Clear Chat</span>
              </button>
              {auth?.role === 'admin' && (
                <button className="user-popup-action admin" onClick={handleAdminClick}>
                  <AdminIcon size={18} />
                  <span>Admin Panel</span>
                </button>
              )}
              <button className="user-popup-action logout" onClick={handleLogout}>
                <LogoutIcon size={18} />
                <span>Sign Out</span>
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UserPopup; 